import {useTranslation} from "@i18n";
import stl from "./NDayGuarantee.module.css";

const NDayGuarantee = (props) => {
  const { t } = useTranslation();
  return (
    <div
      className={[
        stl.container,
        props.className ? props.className : undefined,
      ].join(" ")}
      style={props.style}
    >
      <img src={props.img} alt="days" />
      <div className={stl.content}>
        <strong>
          {t("جربها 10 أيام وإن ما جازتلك رجعها", {
            ns: "web_checkout_cash",
          })}
        </strong>

        <p>
          {t(
            "اشترها الآن وتقدر لأي سبب خلال 10 ايام ترجع السيارة وتسترد كامل فلوسك",
            {
              ns: "web_checkout_cash",
            }
          )}
        </p>
      </div>
    </div>
  );
};

export default NDayGuarantee;
